import { Injectable } from '@angular/core';

@Injectable()
export class AgeService {

  instant(birthdate: any): number {
    let birthdateAsDate = birthdate;
    if (!(birthdate instanceof Date)) {
      birthdateAsDate = new Date(birthdate);
    }
    const ageDifMs = Date.now() - birthdateAsDate.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
}
